import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL ||
  'https://4jbhzumjk7.execute-api.us-east-2.amazonaws.com/prod';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export interface BucketSummaryRequest {
  monthlyAmount: number;
  lifeStage: string;
  buckets: Array<{
    name: string;
    amount: number;
    percent: number;
    description: string;
    where: string;
    timeline: string;
  }>;
  insight: string;
  projection?: {
    years: number;
    totalInvested: number;
    projectedValue: number;
    monthlyDividends: number;
  };
  answers: Record<string, string>;
}

export interface BucketSummaryResponse {
  summary: string;
  cached: boolean;
}

export const bucketService = {
  async getSummary(token: string, data: BucketSummaryRequest): Promise<BucketSummaryResponse> {
    const response = await api.post('/bucket-summary', data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },
};
